import { render, staticRenderFns } from "./ContentTypeListView.vue?vue&type=template&id=e2579bf8&scoped=true"
import script from "./ContentTypeListView.vue?vue&type=script&lang=js"
export * from "./ContentTypeListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2579bf8",
  null
  
)

export default component.exports